export default {
  metaTitle: 'Batch Products Expansion',
  pageTitle: 'Batch Products Expansion',
  coutryStation: 'Coutry Station information',
  exchangeRate: 'Exchange rate',
  overseasFreight: 'Overseas freight (including customs clearance)',
  description1: 'The current store has not yet opened the extension of other countries can not use this function.',
  description2: 'The above is the default information. The seller is allowed to adjust the exchange rate and the Overseas freight',
  description3: `Theoretically, the overseas freight is related to the category. In
    the current operation, there is no obvious difference in the
    overseas freights of different categories, so it is temporarily
    calculated and adjusted when the overseas freight is charged
    according to the category in the subsequent actual business.`,
  extendsPrice: '扩展价格选项',
  placeholder1: '请选择要测试的扩展国家',
  selected: '已选择',
  remarks1: '如果目标扩展国家某个商品(sku)已存在终端价格，则忽略当前商品不执行扩展价格设置。',
  remarks2: '如果当前商品未输入pCost，则忽略当前商品不执行扩展。',
  remarks3: '如果当前商品未设置重量，将采用品类重来应用，价格可能偏差较大，一般情况下，品类重设置的保守(偏高)会造成价格偏高；极少情况下商品实重大于品类重，价格会偏低。',
  remarks4: '如果国内成本、汇率、头程费用变化较大，可先执行清空扩展价格后再重新执行扩展。',
  remarks5: '扩展价格 将按照 (pCost + 商品重量*头程费用) * 汇率 的方式执行。',
  remarks6: '价格扩展应用时，只会应用尚未设置扩展价格的商品。每次10000个商品。',
  remarks7: '清空价格扩展应用时，每次10000个商品。',
  protocol: '我已知悉批量扩展应用可能的风险并同意应用',
  empty: '清空所选扩展国', // 注：语意为：清空所选扩展国({{ country }})的终端价
  prices: '的终端价', // 注：语意为：清空所选扩展国({{ country }})的终端价
  batchExpansion: '批量执行扩展',
  batchExpandPrice: '执行批量扩展价格应用',
  total: 'Total',
  completed: 'Completed',
  extendedCountry: '执行清空扩展国家站的价格',
  commas: 'Please use English commas.',
  sku: 'SKU',
  title: 'Title',
  listPrice: 'ListPrice（指导价)',
  salePrice: 'SalePrice',
  cost: '成本价',
  firstFreight: '头程运费',
  grossWeight: '商品毛重',
  grossMargin: '毛利率',
  costEstimate: '成本预估价',
  byCommas: '请输入以逗号分隔的sku',
  EnglishCommas: '请输入英文逗号',
  selectCountry: '请选择可扩展的国家',
  priceAnalysis: '请进行价格成份分析',
  fillCost: '请填写成本价',
  content1: '您确定执行此操作吗？',
  // --------------------------------------------
  // 注：语意为： 此操作将会把所有已扩展到${this.country}站的商品临时下架并清空终端售价且不可恢复，您确定要执行吗？，
  comfirm1: '此操作将会把所有已扩展到',
  comfirm2: '站的商品临时下架并清空终端售价且不可恢复，您确定要执行吗？',
  // ------------------------------------------------
  // 注:语意为: 清空已完成!共计${this.completedClearing}个
  comfirm3: '清空已完成!共计',
  comfirm4: '个',
  // ------------------------------------------------------
  // 注：语意为：此操作将把所有未扩展到${this.country}站的商品执行扩展并生成${this.country}站的终端销售价，您确定要执行吗?
  comfirm5: '此操作将把所有未扩展到',
  comfirm6: '站的商品执行扩展并生成',
  comfirm7: '站的终端销售价，您确定要执行吗?',
  loading: '队列等待中',
  processing: 'Processing'
}
